import { UpdateCardFunc, useUpdateSingleCardMutation } from "./mutations/useUpdateSingleCardMutation";

import type { UpdateCardQuery } from "../query.types";

export type EditAirTagsFromCardsFunc = (
  params: { id: UpdateCardQuery["id"]; tagsList: string[] },
  options: Parameters<UpdateCardFunc>[1]
) => void;

export type EditAirTagsFromCardsReturnType = {
  editAirTagsFromCards: EditAirTagsFromCardsFunc;
  isAirTagsProcessing: boolean;
  isAirTagsError: boolean;
  isAirTagsSuccess: boolean;
};

export const useAirSavedCardTagsMutation = (): EditAirTagsFromCardsReturnType => {
  const { updateCard, isCardUpdateSuccess, isCardUpdateError, isCardUpdateLoading } = useUpdateSingleCardMutation();

  const editAirTagsFromCards: EditAirTagsFromCardsFunc = (params, options) => {
    updateCard({ id: params.id, data: { tags: params.tagsList } }, options);
  };

  return {
    editAirTagsFromCards,
    isAirTagsProcessing: isCardUpdateLoading,
    isAirTagsError: isCardUpdateError,
    isAirTagsSuccess: isCardUpdateSuccess,
  };
};
